import React, { forwardRef } from 'react';
import classNames from 'classnames';
import MultiFilterPanel from 'components/MultiFilterPanel';
import usePortfolioSellerFilterOptions from './usePortfolioSellerFilterOptions';
import { OpenFieldPanelRef } from 'models/FieldFocusableModal';

import './PortfolioSellerFilters.styles.scss';

type PortfolioSellerFiltersProps = {
  className?: string;
};

const PortfolioSellerFilters: React.ForwardRefRenderFunction<
  OpenFieldPanelRef,
  PortfolioSellerFiltersProps
> = ({ className }, ref) => {
  const classes = classNames('portfolio-seller-filters', className);

  const filterOptions = usePortfolioSellerFilterOptions();

  return (
    <MultiFilterPanel ref={ref} className={classes} filters={filterOptions} />
  );
};

export default forwardRef(PortfolioSellerFilters);
